import React, { useState } from 'react';
import Modal from '../Modal';

interface FDICardDataType {
    id: string;
    className?: string; // For dynamic class assignment
    title: string;
    description: string;
    imageUrl?: string;
    imageAlt?: string;
    iconUrl?: string;
}

interface FDICardsSectionProps {
    cards: FDICardDataType[];
}



// FDICardsSection component
const FDICardsSection: React.FC<FDICardsSectionProps> = ({ cards }) => {

    const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (imageUrl: string) => {
        setModalImageUrl(imageUrl);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImageUrl(null);
    };

    const getCardContent = (card: FDICardDataType) => {
        if (card.iconUrl) {
            return <>
                {card.iconUrl && (
                    <img
                        src={card.iconUrl}
                        loading="lazy"
                        alt={card.imageAlt || ''}
                        className="bento-card-icon"
                    />
                )}
                <div className="wrap-v-small">
                    <h3 className="h4-heading turqoise">
                        <strong>{card.title}</strong>
                    </h3>
                    <div className="description white">{card.description}</div>
                </div>
            </>
        }
        else {
            return <>
                <h3 className="h4-heading">
                    <strong>{card.title}</strong>
                </h3>
                <div className="wrap-v-small">
                    <div className="description">{card.description}</div>
                </div>
                {card.imageUrl && (
                    <img
                        src={card.imageUrl}
                        loading="lazy"
                        alt={card.imageAlt || ''}
                        className="bento-card-image"
                        style={{ cursor: 'pointer' }}
                        onClick={() => openModal(card.imageUrl || "")}
                    />
                )}
            </>
        }
    }

    return (
        <section className="section-regular bg-brown p0-40">
            <div className="container-large">
                <div className="bento-w-heading">
                    <div className="bento-grid-wrapper">
                        <div className="w-layout-grid bento-grid _3-columns">
                            {cards.map((card) => (
                                <div key={card.id} id={card.id} className={`bento-card ${card.className}`}>
                                    <div className="bento-card-header">
                                        {getCardContent(card)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <Modal isOpen={isModalOpen} onClose={closeModal}>
                    {/* Pass dynamic content here */}
                    <img src={modalImageUrl || ""} />
                </Modal>
            )}
        </section>
    );
};

export default FDICardsSection;
